export default function Logo({ size = 34 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" aria-hidden="true">
      <rect x="2" y="2" width="32" height="32" rx="6" fill="none" stroke="#F2A93B" strokeWidth="2.5" />
      <path
        d="M10 28 C14 20, 22 22, 18 14 S 24 8, 26 8"
        fill="none"
        stroke="#F2A93B"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
